import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Checkbox, FormControl, FormLabel, FormGroup, FormControlLabel, FormHelperText } from '@mui/material';
import { List } from '../List/List.js';
import { ListItem } from '../ListItem/ListItem.js';
import '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import keygen from 'uuid/v4';
var _excluded = ["noFormControl", "checkboxGroup", "onChange", "fullWidth", "orientation"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles = {
  checkboxListItemWrapper: {
    padding: 0,
    '&:active': {
      backgroundColor: 'transparent'
    }
  },
  horizontalCheckboxListItemWrapper: {
    display: 'inline'
  }
};

var _DeprecatedCheckbox = function _DeprecatedCheckbox(_ref) {
  var _ref$noFormControl = _ref.noFormControl,
      noFormControl = _ref$noFormControl === void 0 ? false : _ref$noFormControl,
      _ref$checkboxGroup = _ref.checkboxGroup,
      label = _ref$checkboxGroup.label,
      helperText = _ref$checkboxGroup.helperText,
      items = _ref$checkboxGroup.items,
      onChange = _ref.onChange,
      fullWidth = _ref.fullWidth,
      orientation = _ref.orientation,
      rest = _objectWithoutProperties(_ref, _excluded);

  var checkboxKey = "checkbox-id-".concat(keygen());
  var checkboxIteratorKey = 'checkbox-key-';
  var checkboxListItemWrapper = styles.checkboxListItemWrapper,
      horizontalCheckboxListItemWrapper = styles.horizontalCheckboxListItemWrapper;
  return /*#__PURE__*/React.createElement(React.Fragment, null, noFormControl ? items.map(function (_ref2) {
    var isChecked = _ref2.isChecked,
        id = _ref2.id,
        isEnabled = _ref2.isEnabled,
        color = _ref2.color,
        description = _ref2.description;
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: "".concat(checkboxIteratorKey).concat(id),
      checked: isChecked,
      value: id,
      inputProps: {
        'aria-label': description
      },
      disabled: !isEnabled,
      disableRipple: true,
      onChange: onChange && function (event) {
        return onChange(event.currentTarget.value);
      },
      color: color
    });
  }) : /*#__PURE__*/React.createElement(FormControl, _extends({
    fullWidth: fullWidth
  }, rest), /*#__PURE__*/React.createElement(FormLabel, {
    id: checkboxKey,
    className: "Checkbox-FormControl-Label"
  }, label), /*#__PURE__*/React.createElement(FormGroup, {
    role: "group",
    "aria-labelledby": checkboxKey
  }, /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, items.map(function (_ref3, index) {
    var isChecked = _ref3.isChecked,
        id = _ref3.id,
        isEnabled = _ref3.isEnabled,
        color = _ref3.color,
        description = _ref3.description;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: "".concat(checkboxIteratorKey).concat(id),
      dense: true,
      disableGutters: true,
      sx: _objectSpread(_objectSpread({}, checkboxListItemWrapper), orientation === 'horizontal' ? horizontalCheckboxListItemWrapper : null)
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: isChecked,
        value: id,
        size: "small",
        id: "".concat(checkboxKey, "-").concat(index),
        disabled: !isEnabled,
        disableRipple: true,
        onChange: onChange && function (event) {
          return onChange(event.currentTarget.value);
        },
        color: color
      }),
      label: description,
      key: id
    }));
  }))), helperText && /*#__PURE__*/React.createElement(FormHelperText, null, helperText)));
};

_DeprecatedCheckbox.defaultProps = {
  fullWidth: true
};
_DeprecatedCheckbox.displayName = '_DeprecatedCheckbox';
export { _DeprecatedCheckbox };